import {AxiosResponse} from 'axios';
import {Bundle, BundleVersion, Pageable, PaginationSettings, getAxios} from '@deviceinsight/ng-ui-api-client';

import {
	CreateJobRequest,
	UpdateJob,
	JobSchedule,
	CreateGlobalJobRequest,
	GlobalJob
} from '../components/updatejobs/types';
import '../components/updatejobs/types';
import {displayErrorMessage} from './apiUtils';
import {JOB_STATUS} from '../components/updatejobs/consts';

export const createJob = (assetGroupId: number, data: CreateJobRequest): Promise<AxiosResponse<UpdateJob>> => {
	const response: Promise<AxiosResponse<UpdateJob>> = getAxios().post(
		`/rafi/v1/assetGroups/${assetGroupId}/jobs`,
		data
	);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const createGlobalJob = (data: CreateGlobalJobRequest): Promise<AxiosResponse<GlobalJob>> => {
	const response: Promise<AxiosResponse<GlobalJob>> = getAxios().post(`/rafi/v1/globalJobs`, data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const deleteJob = (assetGroupId: number, jobId: string): Promise<void | AxiosResponse<void>> => {
	const promise: Promise<void | AxiosResponse<void>> = getAxios().delete(
		`/rafi/v1/assetGroups/${assetGroupId}/jobs/${jobId}`
	);

	promise.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return promise;
};
export const fetchJobs = (
	assetGroupId: string,
	paginationSettings: PaginationSettings
): Promise<Pageable<UpdateJob>> => {
	const {
		page,
		size,
		sort: {property, direction}
	} = paginationSettings;
	const params = {
		page: page || 0,
		size,
		sort: `${property},${direction}`
	};
	const response = getAxios()
		.get(`/rafi/v1/assetGroups/${assetGroupId}/jobs`, {
			params
		})
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};

export const fetchGlobalJobs = (paginationSettings: PaginationSettings): Promise<Pageable<GlobalJob>> => {
	const {
		page,
		size,
		sort: {property, direction}
	} = paginationSettings;
	const params = {
		page: page || 0,
		size,
		sort: `${property},${direction}`
	};
	const response = getAxios()
		.get(`/rafi/v1/globalJobs`, {
			params
		})
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const fetchPendingOrActiveJobs = (assetGroupId: string) => {
	return getAxios()
		.get(`/rafi/v1/assetGroups/${assetGroupId}/jobs`, {
			params: {
				status: `${JOB_STATUS.PENDING},${JOB_STATUS.ACTIVE}`
			}
		})
		.then((response) => response.data);
};
export const fetchJob = (assetGroupId: number, jobId: string): Promise<UpdateJob> => {
	const response = getAxios()
		.get(`/rafi/v1/assetGroups/${assetGroupId}/jobs/${jobId}`)
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const fetchGlobalJob = (jobId: string): Promise<GlobalJob> => {
	const response = getAxios()
		.get(`/rafi/v1/globalJobs/${jobId}`)
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const fetchBundle = (id: string): Promise<Bundle> => {
	return getAxios()
		.get(`/v2/bundles/${id}`)
		.then((response) => response.data);
};
export const fetchCurrentJobSchedule = (assetGroupId: number): Promise<Pageable<JobSchedule>> => {
	const response = getAxios()
		.get(`/rafi/v1/assetGroups/${assetGroupId}/jobSchedules?status=PENDING`)
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const updateJobSchedule = (
	assetGroupId: number,
	jobScheduleId: string,
	data: JobSchedule
): Promise<JobSchedule> => {
	const response = getAxios()
		.put(`/rafi/v1/assetGroups/${assetGroupId}/jobSchedules/${jobScheduleId}`, data)
		.then((response) => response.data);
	response.catch((e) => displayErrorMessage(e, 'UpdateJobs'));
	return response;
};
export const fetchAllReleasedVersions = (
	bundleId: string,
	paginationSettings: PaginationSettings
): Promise<Pageable<BundleVersion>> => {
	const {
		page,
		size,
		sort: {property, direction}
	} = paginationSettings;
	const params = {
		page: page || 0,
		size,
		sort: `${property},${direction}`
	};
	return getAxios()
		.get(`/v2/bundles/${bundleId}/versions?draft=false`, {
			params
		})
		.then((response) => response.data);
};
export const searchAllJobs = ({
	bundleId,
	bundleVersionId
}: {
	bundleId?: string;
	bundleVersionId?: string;
}): Promise<Pageable<UpdateJob>> => {
	return getAxios()
		.get('/rafi/v1/jobs', {
			params: {
				bundleId,
				bundleVersionId,
				size: 0
			}
		})
		.then((response) => response.data);
};
